export enum AgencyType {
  AGENCY_FOR_OWN_ACCOUNT = 'AGENCY_FOR_OWN_ACCOUNT',
  AGENCY_ON_COMMISSION_BASIS = 'AGENCY_ON_COMMISSION_BASIS',
  BROKER = 'BROKER',
}
